import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

const SITE_URL = 'https://spieloguide.de';
const DEFAULT_IMAGE = SITE_URL + '/assets/logo.png';

export interface SeoData {
    title: string;
    description: string;
    path: string;
    robots?: string;
    image?: string;
}

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(
        private titleService: Title,
        private meta: Meta,
        @Inject(DOCUMENT) private document: Document
    ) { }

    set(data: SeoData) {
        const canonicalUrl = SITE_URL + data.path;
        const image = data.image || DEFAULT_IMAGE;
        const robots = data.robots || 'index, follow';

        this.titleService.setTitle(data.title);

        this.meta.updateTag({ name: 'description', content: data.description });
        this.meta.updateTag({ name: 'robots', content: robots });

        this.meta.updateTag({ property: 'og:title', content: data.title });
        this.meta.updateTag({ property: 'og:description', content: data.description });
        this.meta.updateTag({ property: 'og:url', content: canonicalUrl });
        this.meta.updateTag({ property: 'og:image', content: image });

        this.meta.updateTag({ name: 'twitter:title', content: data.title });
        this.meta.updateTag({ name: 'twitter:description', content: data.description });

        this.setCanonical(canonicalUrl);
    }

    private setCanonical(url: string) {
        let link: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }
        link.setAttribute('href', url);
    }
}
